import * as types from "./types";

export const setMaintenanceSettings = ( data ) => ({
    type: types.SET_MAINTENANCE_SETTINGS,
    payload: data,
});